import BootstrapSpinner from 'react-bootstrap/Spinner';
export default BootstrapSpinner;
//# sourceMappingURL=index.jsx.map